module.exports = require("punycode");


//////////////////
// WEBPACK FOOTER
// external "punycode"
// module id = 469
// module chunks = 0